<template>
  <div ref="shell" class="pc-shell">
    <button v-if="$route.name === 'PcHome'" class="portal-top-ad" type="button" aria-label="查看新人专享活动" @click="goNewcomerCampaign">
      <img :src="portalTopAdImage" alt="新人专享活动">
    </button>
    <div class="top-strip">
      <div class="pc-container top-inner">
        <span class="top-item"><img :src="icons.phone" alt=""> {{ servicePhone }}</span>
        <div class="top-links">
          <div class="supplier-tool">
            <a>供应商合作</a>
            <div v-if="wechatQrCode" class="supplier-qr-card">
              <img :src="wechatQrCode" alt="供应商合作二维码">
              <span>微信扫码洽谈合作</span>
            </div>
          </div>
          <template v-if="!memberUser">
            <a @click="goLogin">登录</a>
            <a class="orange" @click="goLogin">注册</a>
          </template>
          <a v-else class="member-greeting" @click="goMember">您好，{{ memberPhone }}<span v-if="memberUser.accountType === '企业' && memberUser.companyName">（{{ memberUser.companyName }}）</span></a>
          <a @click="goPoints">积分商城</a>
          <a class="cart-link" @click="goCart"><img :src="icons.cart" alt=""> 购物车 <b>{{ cartBadge }}</b></a>
          <a v-if="memberUser" class="logout-link" @click="handleLogout">退出</a>
        </div>
      </div>
    </div>

    <header class="site-header">
      <div class="pc-container header-main">
        <div class="brand" @click="goHome">
          <img class="brand-logo" :src="companyLogo" :alt="companyName">
          <div class="brand-text">
            <strong>{{ companyName }}</strong>
            <span>元器件一站式采购商城</span>
          </div>
        </div>

        <div class="search-area">
          <div class="search-box">
            <input v-model="keyword" placeholder="输入型号/参数" @keyup.enter="search">
            <button class="search-btn" @click="search">搜索</button>
          </div>
          <div v-if="hotSearches.length" class="hot-searches">
            <a
              v-for="item in hotSearches"
              :key="item.id"
              class="hot-search-item"
              @click="searchHot(item)"
            >{{ productSearchText(item) }}</a>
          </div>
        </div>

        <button class="bom-btn" @click="goBom"><img :src="icons.upload" alt=""> 上传BOM</button>
      </div>

      <nav class="main-nav">
        <div class="pc-container nav-inner">
          <a @click="goHome">首页</a>
          <a @click="goProducts">云仓现货</a>
          <a @click="goProducts">芯片·存储</a>
          <a @click="goBom">BOM服务</a>
          <a @click="goSourcing">在线找料</a>
          <a @click="goPoints">积分商城</a>
          <a @click="goNews">公司新闻</a>
          <a @click="goVideos">视频中心</a>
        </div>
      </nav>
    </header>

    <main>
      <div class="pc-page-content"><router-view @cart-change="refreshCart" @profile-change="memberUser = $event" /></div>
    </main>

    <footer class="portal-footer">
      <div class="pc-container footer-inner">
        <div class="footer-group">
          <h2>会员中心</h2>
          <a @click="goMemberProfile">账户信息</a>
          <a @click="goBom">我的BOM</a>
          <a @click="goMemberAddresses">收货地址</a>
          <a @click="goMemberOrders">我的订单</a>
          <a @click="goMemberSourcing">我的找料</a>
          <a @click="goMemberInvoices">我的发票</a>
        </div>
        <div class="footer-group">
          <h2>特色服务</h2>
          <a @click="goProducts">云仓现货</a>
          <a @click="goBom">BOM服务</a>
          <a @click="goPoints">积分商城</a>
          <a @click="goNews">公司新闻</a>
          <a @click="goVideos">视频中心</a>
        </div>
        <div class="footer-service">
          <h2>全国服务热线</h2>
          <strong>{{ servicePhone }}</strong>
          <p>工作时间：9:00-18:00（周一至周六）</p>
          <p v-if="companyAddress">地址：{{ companyAddress }}</p>
          <p class="footer-company"><span>{{ companyName }}</span><img :src="companyLogo" :alt="companyName"></p>
          <div class="footer-qrs">
            <figure v-if="wechatQrCode"><img :src="wechatQrCode" alt="微信二维码"><figcaption>微信二维码</figcaption></figure>
            <figure v-if="miniProgramQrCode"><img :src="miniProgramQrCode" alt="小程序二维码"><figcaption>小程序二维码</figcaption></figure>
            <figure v-if="officialAccountQrCode"><img :src="officialAccountQrCode" alt="公众号二维码"><figcaption>公众号二维码</figcaption></figure>
          </div>
        </div>
      </div>
      <div class="pc-container footer-bottom"><span>电子元器件一站式采购服务平台</span></div>
    </footer>

    <aside class="fixed-tools">
      <div class="wechat-tool">
        <button>
          <img :src="icons.inquiry" alt="">
          <span>微信咨询</span>
        </button>
        <div v-if="wechatQrCode" class="wechat-qr-card">
          <img :src="wechatQrCode" alt="微信咨询二维码">
          <span>微信扫码咨询</span>
        </div>
      </div>
      <button v-for="item in fixedTools" :key="item.label" @click="item.action && item.action()">
        <img :src="item.icon" alt="">
        <span>{{ item.label }}</span>
      </button>
    </aside>
  </div>
</template>

<script>
  import { message } from 'ant-design-vue'
  import { getCartSummary } from '@/utils/pcCart'
  import pcAuth from '@/utils/pcAuth'
  import { getPcMallSettings, getPcHotProducts, getPcMemberProfile, createPcTrackingEvent } from '@/api/pc'
  import commerce from '@/utils/pcCommerce'

  const pcIcons = {
    home: require('@/assets/icons/pc/home.svg'),
    phone: require('@/assets/icons/pc/phone.svg'),
    cart: require('@/assets/icons/pc/cart.svg'),
    down: require('@/assets/icons/pc/chevron-down.svg'),
    upload: require('@/assets/icons/pc/upload.svg'),
    inquiry: require('@/assets/icons/pc/inquiry.svg'),
    order: require('@/assets/icons/pc/order.svg')
  }

  export default {
    name: 'PcLayout',
    data() {
      return {
        keyword: '',
        cartBadge: '0',
        memberUser: pcAuth.getToken() ? pcAuth.getUser() : null,
        setting: {},
        hotSearches: [],
        logo: require('@/assets/logo.png'),
        portalTopAdImage: `${process.env.BASE_URL || '/'}portal-top-ad.jpg`,
        icons: pcIcons
      }
    },
    computed: {
      memberPhone() {
        const user = this.memberUser || {}
        return user.maskedPhone || pcAuth.maskPhone(user.registeredPhone || user.phone)
      },
      companyName() { return this.setting.companyName || '锐高科技' },
      companyAddress() { return this.setting.companyAddress || '' },
      servicePhone() { return this.setting.servicePhone || '400-862-6630' },
      companyLogo() { return this.setting.companyLogo ? commerce.normalizeAssetPath(this.setting.companyLogo) : this.logo },
      wechatQrCode() { return this.setting.wechatQrCode ? commerce.normalizeAssetPath(this.setting.wechatQrCode) : '' },
      miniProgramQrCode() { return this.setting.miniProgramQrCode ? commerce.normalizeAssetPath(this.setting.miniProgramQrCode) : '' },
      officialAccountQrCode() { return this.setting.officialAccountQrCode ? commerce.normalizeAssetPath(this.setting.officialAccountQrCode) : '' },
      fixedTools() {
        return [
          { label: '会员中心', icon: pcIcons.order, action: this.goMember },
          { label: '在线找料', icon: pcIcons.inquiry, action: this.goSourcing },
          { label: '购物车', icon: pcIcons.cart, action: this.goCart }
        ]
      }
    },
    created() {
      this.refreshCart()
      this.loadCompanySetting()
      this.loadHotSearches()
      if (pcAuth.getToken()) getPcMemberProfile().then(user => { this.memberUser = user; pcAuth.saveUser(user) }).catch(() => {})
    },
    watch: {
      '$route.fullPath'() {
        this.$nextTick(this.scrollToTop)
      }
    },
    methods: {
      scrollToTop() {
        const shell = this.$refs.shell
        if (!shell) return
        if (typeof shell.scrollTo === 'function') {
          shell.scrollTo({ top: 0, left: 0, behavior: 'auto' })
        } else {
          shell.scrollTop = 0
        }
      },
      loadCompanySetting() {
        getPcMallSettings().then(data => { this.setting = data || {} }).catch(() => { this.setting = {} })
      },
      loadHotSearches() {
        getPcHotProducts().then(data => {
          this.hotSearches = (Array.isArray(data) ? data : []).filter(item => item && item.id).slice(0, 4)
        }).catch(() => { this.hotSearches = [] })
      },
      productSearchText(item) {
        const model = item && String(item.model || '').trim()
        return model || String((item && item.name) || '').trim()
      },
      searchHot(item) {
        const text = this.productSearchText(item)
        if (!text) return
        this.keyword = text
        this.search()
      },
      refreshCart() {
        const summary = getCartSummary()
        this.cartBadge = summary.productCount > 99 ? '99+' : String(summary.productCount)
      },
      goHome() {
        this.$router.push('/pc')
      },
      goNewcomerCampaign() {
        this.$router.push('/pc/newcomer-campaign')
      },
      goLogin() {
        this.$router.push({ path: '/pc/login', query: { redirect: this.$route.fullPath } })
      },
      goProducts() {
        this.$router.push('/pc/products')
      },
      goCart() {
        this.$router.push('/pc/cart')
      },
      handleLogout() {
        pcAuth.clearLogin()
        this.memberUser = null
        message.success('已退出登录')
        if (this.$route.path !== '/pc') this.$router.replace('/pc')
      },
      goMember() {
        this.$router.push('/pc/member')
      },
      goMemberProfile() {
        this.$router.push('/pc/member/profile')
      },
      goMemberAddresses() {
        this.$router.push('/pc/member/addresses')
      },
      goMemberOrders() {
        this.$router.push('/pc/member/orders')
      },
      goMemberInvoices() {
        this.$router.push('/pc/member/invoices')
      },
      goBom() {
        this.$router.push('/pc/bom')
      },
      goSourcing() {
        this.$router.push({ path: '/pc/sourcing', query: this.keyword ? { model: this.keyword } : {} })
      },
      goMemberSourcing() {
        this.$router.push('/pc/member/sourcing')
      },
      goPoints() {
        this.$router.push('/pc/points')
      },
      goNews() {
        this.$router.push('/pc/news')
      },
      goVideos() {
        this.$router.push('/pc/videos')
      },
      search() {
        this.$router.push({
          path: '/pc/products',
          query: this.keyword ? { keyword: this.keyword, searchEvent: createPcTrackingEvent('search') } : {}
        })
      }
    }
  }
</script>

<style scoped>
  .pc-page-content { min-height: 320px; }
  .pc-shell {
    min-width: 1200px;
    height: 100vh;
    overflow-y: auto;
    background: #f5f7fa;
    color: #1f2937;
    font-family: Arial, "Microsoft YaHei", sans-serif;
  }

  .pc-shell,
  .pc-shell * {
    scrollbar-width: thin;
    scrollbar-color: #b8c2cf transparent;
  }

  .pc-shell::-webkit-scrollbar,
  .pc-shell *::-webkit-scrollbar {
    width: 3px;
    height: 3px;
  }

  .pc-shell::-webkit-scrollbar-track,
  .pc-shell *::-webkit-scrollbar-track {
    background: transparent;
  }

  .pc-shell::-webkit-scrollbar-thumb,
  .pc-shell *::-webkit-scrollbar-thumb {
    border-radius: 3px;
    background: #b8c2cf;
  }

  .pc-container {
    width: 1200px;
    max-width: none;
    margin: 0 auto;
    box-sizing: border-box;
  }

  .portal-top-ad {
    display: block;
    width: 100%;
    padding: 0;
    border: 0;
    background: #fff;
    cursor: pointer;
    line-height: 0;
  }

  .portal-top-ad img {
    display: block;
    width: 100%;
    height: auto;
  }

  .top-strip {
    position: relative;
    z-index: 40;
    height: 30px;
    overflow: visible;
    background: #e5e5e5;
    font-size: 12px;
  }

  .top-inner {
    height: 30px;
    display: flex;
    align-items: center;
    gap: 16px;
  }

  .top-item,
  .cart-link {
    display: inline-flex;
    align-items: center;
    gap: 4px;
  }

  .top-item img,
  .cart-link img {
    width: 14px;
    height: 14px;
    object-fit: contain;
  }

  .top-links {
    margin-left: auto;
    display: flex;
    align-items: center;
    gap: 18px;
  }

  .supplier-tool { position: relative; }

  .supplier-qr-card {
    position: absolute;
    z-index: 40;
    top: 24px;
    left: 50%;
    width: 132px;
    padding: 10px;
    border: 1px solid #d8e8f8;
    border-radius: 6px;
    background: #fff;
    color: #475569;
    text-align: center;
    box-shadow: 0 8px 24px rgba(15, 23, 42, .14);
    opacity: 0;
    visibility: hidden;
    transform: translate(-50%, 6px);
    transition: opacity .18s ease, transform .18s ease, visibility .18s ease;
    pointer-events: none;
  }

  .supplier-qr-card img { display: block; width: 112px; height: 112px; margin: 0 auto 6px; object-fit: contain; }
  .supplier-tool:hover .supplier-qr-card,
  .supplier-tool:focus-within .supplier-qr-card { opacity: 1; visibility: visible; transform: translate(-50%, 0); }

  .member-greeting { color: #0b3b91; }

  .logout-link { color: #64748b; }

  .logout-link:hover { color: #ff4d00; }

  a {
    color: inherit;
    cursor: pointer;
  }

  .orange,
  .red {
    color: #ff4d00;
  }

  .top-links b {
    display: inline-block;
    min-width: 16px;
    height: 16px;
    border-radius: 3px;
    background: #ff5a00;
    color: #fff;
    text-align: center;
    line-height: 16px;
  }

  .site-header {
    background: #fff;
    border-bottom: 2px solid #1684ff;
  }

  .header-main {
    height: 96px;
    display: grid;
    grid-template-columns: 260px minmax(0, 1fr) 130px;
    align-items: center;
    gap: 12px;
    padding: 0 12px;
  }

  .brand {
    display: flex;
    align-items: center;
    gap: 14px;
    cursor: pointer;
    min-width: 0;
  }

  .brand-logo {
    display: block;
    width: 74px;
    height: 74px;
    object-fit: contain;
  }

  .brand-text strong,
  .brand-text span {
    display: block;
  }

  .brand-text { height: 40px; }

  .brand-text strong {
    color: #0b3b91;
    font-size: 22px;
    line-height: 28px;
  }

  .brand-text span {
    margin-top: 2px;
    color: #6b7280;
    font-size: 12px;
    white-space: nowrap;
  }

  .search-area {
    min-width: 0;
    align-self: center;
    position: relative;
  }

  .search-box {
    height: 40px;
    display: grid;
    grid-template-columns: 1fr 82px;
    border: 2px solid #0b3b91;
    border-radius: 7px;
    overflow: hidden;
  }

  .search-box input,
  .search-box button {
    border: 0;
    outline: 0;
    background: #fff;
  }

  .search-box input {
    padding: 0 12px;
    font-size: 14px;
  }

  .hot-searches {
    position: absolute;
    top: 40px;
    left: 0;
    max-width: 100%;
    height: 24px;
    display: flex;
    align-items: center;
    gap: 18px;
    overflow: hidden;
    white-space: nowrap;
    font-size: 13px;
    line-height: 24px;
  }

  .hot-search-item {
    color: #1684ff;
    cursor: pointer;
    flex: 0 0 auto;
  }

  .hot-search-item:hover {
    text-decoration: underline;
  }

  .search-btn {
    background: #0b3b91 !important;
    color: #fff;
    font-weight: 700;
  }

  .bom-btn {
    width: 112px;
    height: 40px;
    border: 0;
    border-radius: 5px;
    background: #dcfce7;
    color: #00a13a;
    font-weight: 700;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    gap: 6px;
    cursor: pointer;
    justify-self: start;
    align-self: center;
  }

  .bom-btn img {
    width: 18px;
    height: 18px;
  }

  .main-nav {
    height: 50px;
  }

  .nav-inner {
    height: 50px;
    display: flex;
    align-items: center;
    gap: 18px;
    padding-left: 12px;
    font-size: 16px;
    box-sizing: border-box;
  }

  .nav-inner a {
    padding: 9px 18px;
    border-radius: 5px;
    transition: color .2s ease, background-color .2s ease;
  }

  .nav-inner a:hover {
    color: #fff;
    background: #1684ff;
  }

  .portal-footer {
    margin-top: 18px;
    background: #eef2f7;
    color: #475569;
  }

  .footer-inner {
    min-height: 210px;
    padding: 26px 34px;
    border-top: 1px solid #d8dee8;
    border-bottom: 1px solid #d8dee8;
    display: grid;
    grid-template-columns: minmax(180px, 1fr) minmax(180px, 1fr) minmax(340px, 1.5fr);
    gap: 70px;
  }

  .footer-group {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    gap: 11px;
  }

  .footer-group h2,
  .footer-service h2 {
    margin: 0 0 3px;
    color: #1f2937;
    font-size: 16px;
  }

  .footer-group a {
    color: #64748b;
    font-size: 13px;
  }

  .footer-group a:hover {
    color: #1684ff;
  }

  .footer-service {
    padding-left: 48px;
    border-left: 1px solid #d8dee8;
  }

  .footer-service strong {
    display: block;
    margin: 8px 0 15px;
    color: #0b3b91;
    font-size: 32px;
    line-height: 38px;
  }

  .footer-service p {
    margin: 7px 0;
    font-size: 13px;
  }

  .footer-company { display: flex; align-items: center; gap: 8px; }

  .footer-company img { width: 32px; height: 32px; object-fit: contain; }

  .footer-qrs { margin-top: 10px; display: flex; gap: 14px; }

  .footer-qrs figure { margin: 0; color: #64748b; font-size: 11px; text-align: center; }

  .footer-qrs img { width: 62px; height: 62px; object-fit: contain; border-radius: 3px; background: #fff; }

  .footer-bottom {
    position: relative;
    height: 42px;
    display: flex;
    align-items: center;
    justify-content: center;
    color: #94a3b8;
    font-size: 12px;
  }

  .fixed-tools {
    position: fixed;
    z-index: 20;
    right: 14px;
    top: 300px;
    width: 72px;
    background: #fff;
    border: 1px solid #e5e7eb;
  }

  .fixed-tools button {
    width: 70px;
    min-height: 64px;
    border: 0;
    border-bottom: 1px solid #e5e7eb;
    background: #fff;
    color: #1684ff;
    font-size: 12px;
    cursor: pointer;
  }

  .fixed-tools button {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    gap: 4px;
  }

  .fixed-tools button img {
    width: 18px;
    height: 18px;
    filter: brightness(0) saturate(100%) invert(44%) sepia(93%) saturate(1969%) hue-rotate(184deg) brightness(96%) contrast(103%);
  }

  .wechat-tool {
    position: relative;
  }

  .wechat-qr-card {
    position: absolute;
    right: calc(100% + 8px);
    top: 0;
    width: 132px;
    padding: 10px;
    border: 1px solid #d8e8f8;
    border-radius: 6px;
    background: #fff;
    color: #1684ff;
    text-align: center;
    box-shadow: 0 8px 24px rgba(15, 23, 42, .14);
    opacity: 0;
    visibility: hidden;
    transform: translateX(6px);
    transition: opacity .18s ease, transform .18s ease, visibility .18s ease;
    pointer-events: none;
  }

  .wechat-qr-card img {
    display: block;
    width: 112px !important;
    height: 112px !important;
    margin: 0 auto 6px;
    object-fit: contain;
    filter: none !important;
  }

  .wechat-qr-card span {
    font-size: 12px;
  }

  .wechat-tool:hover .wechat-qr-card,
  .wechat-tool:focus-within .wechat-qr-card {
    opacity: 1;
    visibility: visible;
    transform: translateX(0);
  }

</style>

